import { WidgetConfigModalProps } from '@/types.ts';

import { useWidgetSiteTabbedShellSave } from './useWidgetSiteTabbedShellSave.ts';
import {
  WidgetConfigSiteTabbedShellContent,
  type WidgetConfigSiteTabbedShellContentProps,
} from './widgetConfigSiteTabbedShell/WidgetConfigSiteTabbedShellContent.tsx';
import { WidgetSiteTabbedShellProvider } from './widgetConfigSiteTabbedShell/WidgetSiteTabbedShellProvider.tsx';

type WidgetConfigSiteTabbedShellProps = WidgetConfigSiteTabbedShellContentProps &
  Pick<WidgetConfigModalProps, 'widgetId'> & {
    defaultSiteKey?: string;
  };

/** Site-tabbed widget config body plus standard close/back footer. */
export const WidgetConfigSiteTabbedShell = ({
  defaultSiteKey,
  widgetId,
  onSave,
  ...shellContentProps
}: WidgetConfigSiteTabbedShellProps) => {
  const handleSave = useWidgetSiteTabbedShellSave(widgetId, onSave);

  return (
    <WidgetSiteTabbedShellProvider widgetId={widgetId} defaultSiteKey={defaultSiteKey}>
      <WidgetConfigSiteTabbedShellContent {...shellContentProps} onSave={handleSave} />
    </WidgetSiteTabbedShellProvider>
  );
};
